import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BaseApiService } from "../../../common/services/base-api-service";
import { Customer } from "../../../common/interfaces/Customer";
import { MatDialog } from "@angular/material/dialog";
import { ChangeInfoDialogComponent } from "./change-info-dialog/change-info-dialog.component";
import { Router } from "@angular/router";
import { CustomerApi } from "../../../common/apis/customer-api";
import { FirestoreService } from "../../../common/services/firestore.service";
import { generateFilePaths } from "../../../common/utilities/General";
import { FileUpload } from "../../../common/interfaces/FileUpload";
import { RedirectService } from "../../../common/services/redirect.service";

export declare type FieldType = "name" | "password" | "mobile"
@Component({
  selector: 'app-customer-profile',
  templateUrl: './customer-profile.component.html',
  styleUrls: ['./customer-profile.component.scss']
})

export class CustomerProfileComponent implements OnInit {

  customer: Customer | null = null
  defaultProfilePicture = "assets/customer-profile-placeholder.svg"
  @ViewChild('FileSelectInputDialog') FileSelectInputDialog!: ElementRef;
  nameLabel = $localize`:@@changeYourName:Change your name`
  mobileNumberLabel = $localize`:@@changeMobileNumber:Change mobile number`
  passwordLabel = $localize`:@@changePassword:Change password`

  maxFileSizeBytes = 5 * 1024 * 1024
  errorMessage: string


  constructor(
    private baseApi: BaseApiService,
    public dialog: MatDialog,
    private router: Router,
    private baseApiService: BaseApiService,
    private customerApi: CustomerApi,
    private uploadService: FirestoreService,
    private redirectService: RedirectService
  ) {
  }

  imageUrl: string | ArrayBuffer | null = null;
  isUploadImageLoading = false

  ngOnInit(): void {
    let customer = this.baseApi.getJwt()?.customer
    if (customer) {
      this.customer = customer
      console.log(this.customer)
    } else {
      let errorMessage = $localize`:@@pleaseLoginToAccessYourAccount:Please login to access your account.`

      let currentPage =  this.router.url;
      this.redirectService.setRedirectUrl(currentPage);
      this.redirectService.setWarningMessage(errorMessage)
      this.router.navigate(["login"]).then()
      // this.router.navigate(["/"]).then()
    }
  }

  getPicture(): string | ArrayBuffer | null {
    if (this.imageUrl) {
      return this.imageUrl;  // Use the selected image if it exists
    } else if (this.customer?.profilePictureURL) {
      return this.customer.profilePictureURL;  // Use the customer's existing profile picture
    } else {
      return this.defaultProfilePicture;  // Use a default profile picture
    }
  }

  selectPicture(event: any) {
    const element: HTMLElement = this.FileSelectInputDialog.nativeElement;
    element.click();
  }


  retrieveImage(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imageUrl = reader.result;
      };
      reader.readAsDataURL(file);

      this.sendToServer(file);
    }
  }

  sendToServer(file: File) {
    this.isUploadImageLoading = true
    let filePaths = generateFilePaths({
      customerId: this.customer?.id ?? "",
    });
    let  profilePicturePath  = filePaths.profilePicturePath;
    let fileUpload = new FileUpload(file)
    this.uploadService.pushFileToStorage(fileUpload,profilePicturePath).subscribe({
      next: result => {
        console.log("result =", result);
        if (typeof result === 'string') {
          this.customer!.profilePictureURL = result
          this.updateCustomer(this.customer!)
        }
      },
      error: () => {
        console.log("pushFileToStorage.error")
      }
    });
  }



  removeProfilePic() {
    this.FileSelectInputDialog.nativeElement.value = '';

    if(this.customer) {
      this.isUploadImageLoading = true
      this.customer!.profilePictureURL = null
      this.updateCustomer(this.customer)
    }
  }

  updateCustomer(customer:Customer) {
    this.imageUrl = customer.profilePictureURL
      this.customerApi.updateCustomerInfo(this.customer!).subscribe({
        next: (_) => {
          if(this.baseApiService.getJwt() && this.baseApiService.getJwt()?.customer)
          {
            this.baseApiService.saveJWTToken(Object.assign({}, this.baseApiService.getJwt(), {customer: customer}))
            this.isUploadImageLoading = false
          }
        },
        error: (error) => {
          this.isUploadImageLoading = false
          console.log(error)
          if (Array.isArray(error)) {
            //TODO Set error message here
          }
        }
      })

  }


  getPhoneNumber() {
    return `${this.customer?.countryCode}${this.customer?.phoneNumber}`
  }

  changeUserName() {
    this.dialog.open(ChangeInfoDialogComponent, {
      data: {
        title: this.nameLabel,
        fieldType: "name"
      },
      width: '37rem',
      autoFocus: false
    }).afterClosed()
      .subscribe({
        next: (_) => {
          this.customer = this.baseApi.getJwt()?.customer!
        }
      });
  }

  changeMobileNumber() {
    this.dialog.open(ChangeInfoDialogComponent, {
      data: {
        title: this.mobileNumberLabel,
        fieldType: "mobile"
      },
      width: '37rem',
      autoFocus: false
    }).afterClosed()
      .subscribe({
        next: (_) => {
          this.customer = this.baseApi.getJwt()?.customer!
        }
      });
  }

  changePassword() {
    this.dialog.open(ChangeInfoDialogComponent, {
      data: {
        title: this.passwordLabel,
        fieldType: "password"
      },
      width: '37rem',
      autoFocus: false
    }).afterClosed()
      .subscribe({
        next: (_) => {
          this.customer = this.baseApi.getJwt()?.customer!
        }
      });
  }
}
